import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RecordHeaderComponent } from './record-header.component';
import { RecordHeaderContentComponent } from './record-header-content/record-header-content.component';
import { BubbleTimelineModule } from '@components/bubble-timeline/bubble-timeline.module';
import { SharedModule } from '@shared/shared.module';

@NgModule({
  imports: [CommonModule, BubbleTimelineModule, SharedModule],
  declarations: [RecordHeaderComponent, RecordHeaderContentComponent],
  exports: [RecordHeaderComponent, RecordHeaderContentComponent]
})
export class RecordHeaderModule {}
